import React, { useCallback, useEffect, useState } from 'react';

const COLS = [
  { key: 'Received', tone: 'border-slate-500', head: 'bg-slate-700' },
  { key: 'In Repair', tone: 'border-amber-500', head: 'bg-amber-600' },
  { key: 'Done', tone: 'border-emerald-500', head: 'bg-emerald-600' },
  { key: 'Returned', tone: 'border-blue-500', head: 'bg-blue-600' },
];

const MAX_TILES = 6;

const ago = (iso) => {
  if (!iso) return '—';
  const mins = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 60000));
  if (mins < 60) return `${mins}m`;
  const h = Math.floor(mins / 60);
  return h < 48 ? `${h}h` : `${Math.floor(h / 24)}d`;
};

const MachineTile = ({ c }) => (
  <div className={`rounded-md p-3 border-l-4 ${c.priority === 'Rush' ? 'bg-red-950/60 border-red-500 ring-1 ring-red-500/60' : 'bg-slate-900 border-slate-700'}`} data-testid={`tv-repair-card-${c.machine_id}`}>
    <div className="flex items-center justify-between gap-2">
      <span className="font-mono font-black text-xl truncate">{c.serial_number || '—'}</span>
      {c.priority === 'Rush' && <span className="text-[11px] font-black bg-red-600 px-2 py-0.5 rounded-sm animate-pulse">RUSH</span>}
    </div>
    <div className="text-sm text-slate-300 truncate">{c.model || '—'}</div>
    <div className="text-sm text-white/90 truncate mt-0.5">{c.customer || '—'}</div>
    <div className="flex items-center justify-between text-xs text-slate-400 mt-1.5">
      <span className="font-mono">{c.ro_number}{c.technician ? ` · ${c.technician}` : ''}</span>
      <span className="font-mono text-orange-300" title="Time in this status">{ago(c.since)}</span>
    </div>
  </div>
);

export const RepairBoardViewpoint = ({ api, refreshMs = 60000 }) => {
  const [data, setData] = useState(null);
  const fetchData = useCallback(async () => {
    try { const r = await api().get('/tv/repair-board'); setData(r.data); } catch { /* keep last */ }
  }, [api]);
  useEffect(() => { fetchData(); const i = setInterval(fetchData, refreshMs); return () => clearInterval(i); }, [fetchData, refreshMs]);

  return (
    <div className="flex-1 grid grid-cols-4 gap-4 p-6 overflow-hidden" data-testid="tv-repair-board">
      {COLS.map(col => {
        const items = data?.columns?.[col.key] || [];
        return (
          <div key={col.key} className={`flex flex-col min-h-0 rounded-md border-t-4 ${col.tone} bg-slate-950/40`} data-testid={`tv-repair-col-${col.key.replace(' ', '-').toLowerCase()}`}>
            <div className={`${col.head} px-4 py-3 flex items-center justify-between rounded-t-sm`}>
              <span className="text-2xl font-bold uppercase tracking-wider">{col.key}</span>
              <span className="font-mono font-black text-4xl" data-testid={`tv-repair-count-${col.key.replace(' ', '-').toLowerCase()}`}>{items.length}</span>
            </div>
            <div className="flex-1 overflow-hidden p-3 space-y-2 min-h-0">
              {items.slice(0, MAX_TILES).map(c => <MachineTile key={`${c.ro_id}-${c.machine_id}`} c={c} />)}
              {!items.length && <p className="text-center text-slate-500 italic mt-6">None</p>}
            </div>
            {items.length > MAX_TILES && <p className="text-center text-orange-300 font-semibold text-base py-2 border-t border-slate-800" data-testid={`tv-repair-more-${col.key.replace(' ', '-').toLowerCase()}`}>+{items.length - MAX_TILES} more</p>}
          </div>
        );
      })}
    </div>
  );
};

export default RepairBoardViewpoint;
